@file:Suppress(
    "RETURN_VALUE_NOT_USED",
    "RETURN_VALUE_NOT_USED_COERCION",
)

import com.varabyte.kobweb.core.AppGlobals
import com.varabyte.kobweb.navigation.BasePath
import com.varabyte.kobweb.navigation.Router
import com.varabyte.kobweb.navigation.UpdateHistoryMode
import com.varabyte.kobweb.navigation.remove
import kotlin.Suppress
import kotlinx.browser.document
import kotlinx.browser.window
import org.jetbrains.compose.web.renderComposable
import meineglasfaser.frontend.www.components.layouts.PortalLayout as _meineglasfaser_frontend_www_components_layouts_PortalLayout
import meineglasfaser.frontend.www.components.layouts.RegisterLayout as _meineglasfaser_frontend_www_components_layouts_RegisterLayout
import meineglasfaser.frontend.www.components.layouts.ShopLayout as _meineglasfaser_frontend_www_components_layouts_ShopLayout
import meineglasfaser.frontend.www.pages.BasketPage as _meineglasfaser_frontend_www_pages_BasketPage
import meineglasfaser.frontend.www.pages.LandingPage as _meineglasfaser_frontend_www_pages_LandingPage
import meineglasfaser.frontend.www.pages.WiderrufsrechtPage as _meineglasfaser_frontend_www_pages_WiderrufsrechtPage
import meineglasfaser.frontend.www.pages.explore.AudiencePage as _meineglasfaser_frontend_www_pages_explore_AudiencePage
import meineglasfaser.frontend.www.pages.explore.CategoryPage as _meineglasfaser_frontend_www_pages_explore_CategoryPage
import meineglasfaser.frontend.www.pages.explore.NetworkPage as _meineglasfaser_frontend_www_pages_explore_NetworkPage
import meineglasfaser.frontend.www.pages.explore.ProductPage as _meineglasfaser_frontend_www_pages_explore_ProductPage
import meineglasfaser.frontend.www.pages.order.OrderPage as _meineglasfaser_frontend_www_pages_order_OrderPage
import meineglasfaser.frontend.www.pages.order.OrderSuccessPage as _meineglasfaser_frontend_www_pages_order_OrderSuccessPage
import meineglasfaser.frontend.www.pages.portal.MyAccountPage as _meineglasfaser_frontend_www_pages_portal_MyAccountPage
import meineglasfaser.frontend.www.pages.portal.MyDataPage as _meineglasfaser_frontend_www_pages_portal_MyDataPage
import meineglasfaser.frontend.www.pages.portal.OrdersPage as _meineglasfaser_frontend_www_pages_portal_OrdersPage
import meineglasfaser.frontend.www.pages.portal.OverviewPage as _meineglasfaser_frontend_www_pages_portal_OverviewPage
import meineglasfaser.frontend.www.pages.portal.auth.ForgotPage as _meineglasfaser_frontend_www_pages_portal_auth_ForgotPage
import meineglasfaser.frontend.www.pages.portal.auth.ForgotPage2 as _meineglasfaser_frontend_www_pages_portal_auth_ForgotPage2
import meineglasfaser.frontend.www.pages.portal.auth.LoginPage as _meineglasfaser_frontend_www_pages_portal_auth_LoginPage
import meineglasfaser.frontend.www.pages.portal.auth.LogoutPage as _meineglasfaser_frontend_www_pages_portal_auth_LogoutPage
import meineglasfaser.frontend.www.pages.portal.auth.RegisterPage as _meineglasfaser_frontend_www_pages_portal_auth_RegisterPage
import meineglasfaser.frontend.www.pages.portal.auth.VerifyPage as _meineglasfaser_frontend_www_pages_portal_auth_VerifyPage
import meineglasfaser.frontend.www.pages.registrierung.RegistrierungPage as _meineglasfaser_frontend_www_pages_registrierung_RegistrierungPage

public fun main() {
    AppGlobals.initialize(mapOf("title" to "Prometheus Network"))
    BasePath.set("")
    val router = Router()
    com.varabyte.kobweb.core.init.initKobweb(router) { ctx ->
        ctx.router.registerLayout(
            "meineglasfaser.frontend.www.components.layouts.PortalLayout",
        ) { pageCtx, pageMethod -> 
            _meineglasfaser_frontend_www_components_layouts_PortalLayout(pageCtx) {
                pageMethod(pageCtx)
            }
        }
        ctx.router.registerLayout(
            "meineglasfaser.frontend.www.components.layouts.RegisterLayout",
        ) { pageCtx, pageMethod -> 
            _meineglasfaser_frontend_www_components_layouts_RegisterLayout {
                pageMethod(pageCtx)
            }
        }
        ctx.router.registerLayout(
            "meineglasfaser.frontend.www.components.layouts.ShopLayout",
        ) { pageCtx, pageMethod -> 
            _meineglasfaser_frontend_www_components_layouts_ShopLayout {
                pageMethod(pageCtx)
            }
        }
        ctx.router.register(
            "/",
            layoutId = "meineglasfaser.frontend.www.components.layouts.ShopLayout",
        ) { pageCtx -> 
            _meineglasfaser_frontend_www_pages_LandingPage(pageCtx)
        }
        ctx.router.register(
            "/basket",
            layoutId = "meineglasfaser.frontend.www.components.layouts.ShopLayout",
        ) { pageCtx -> 
            _meineglasfaser_frontend_www_pages_BasketPage()
        }
        ctx.router.register(
            "/entdecken/{audience}",
            layoutId = "meineglasfaser.frontend.www.components.layouts.ShopLayout",
        ) { pageCtx -> 
            _meineglasfaser_frontend_www_pages_explore_AudiencePage(pageCtx)
        }
        ctx.router.register(
            "/entdecken/{audience}/{category}",
            layoutId = "meineglasfaser.frontend.www.components.layouts.ShopLayout",
        ) { pageCtx -> 
            _meineglasfaser_frontend_www_pages_explore_CategoryPage(pageCtx)
        }
        ctx.router.register(
            "/entdecken/{audience}/{category}/{network}",
            layoutId = "meineglasfaser.frontend.www.components.layouts.ShopLayout",
        ) { pageCtx -> 
            _meineglasfaser_frontend_www_pages_explore_NetworkPage(pageCtx)
        }
        ctx.router.register(
            "/entdecken/{audience}/{category}/{network}/{nid}",
            layoutId = "meineglasfaser.frontend.www.components.layouts.ShopLayout",
        ) { pageCtx -> 
            _meineglasfaser_frontend_www_pages_explore_ProductPage(pageCtx)
        }
        ctx.router.register(
            "/kundenportal/auth/forgot/stage1",
            layoutId = "meineglasfaser.frontend.www.components.layouts.ShopLayout",
        ) { pageCtx -> 
            _meineglasfaser_frontend_www_pages_portal_auth_ForgotPage()
        }
        ctx.router.register(
            "/kundenportal/auth/forgot/stage2",
            layoutId = "meineglasfaser.frontend.www.components.layouts.ShopLayout",
        ) { pageCtx -> 
            _meineglasfaser_frontend_www_pages_portal_auth_ForgotPage2(pageCtx)
        }
        ctx.router.register(
            "/kundenportal/auth/login",
            layoutId = "meineglasfaser.frontend.www.components.layouts.ShopLayout",
        ) { pageCtx -> 
            _meineglasfaser_frontend_www_pages_portal_auth_LoginPage(pageCtx)
        }
        ctx.router.register(
            "/kundenportal/auth/logout",
            layoutId = "meineglasfaser.frontend.www.components.layouts.ShopLayout",
        ) { pageCtx -> 
            _meineglasfaser_frontend_www_pages_portal_auth_LogoutPage(pageCtx)
        }
        ctx.router.register(
            "/kundenportal/auth/register",
            layoutId = "meineglasfaser.frontend.www.components.layouts.ShopLayout",
        ) { pageCtx -> 
            _meineglasfaser_frontend_www_pages_portal_auth_RegisterPage(pageCtx)
        }
        ctx.router.register(
            "/kundenportal/auth/verify",
            layoutId = "meineglasfaser.frontend.www.components.layouts.ShopLayout",
        ) { pageCtx -> 
            _meineglasfaser_frontend_www_pages_portal_auth_VerifyPage(pageCtx)
        }
        ctx.router.register(
            "/kundenportal/my-account",
            layoutId = "meineglasfaser.frontend.www.components.layouts.PortalLayout",
        ) { pageCtx -> 
            _meineglasfaser_frontend_www_pages_portal_MyAccountPage()
        }
        ctx.router.register(
            "/kundenportal/my-data",
            layoutId = "meineglasfaser.frontend.www.components.layouts.PortalLayout",
        ) { pageCtx -> 
            _meineglasfaser_frontend_www_pages_portal_MyDataPage()
        }
        ctx.router.register(
            "/kundenportal/orders",
            layoutId = "meineglasfaser.frontend.www.components.layouts.PortalLayout",
        ) { pageCtx -> 
            _meineglasfaser_frontend_www_pages_portal_OrdersPage()
        }
        ctx.router.register(
            "/kundenportal/overview",
            layoutId = "meineglasfaser.frontend.www.components.layouts.PortalLayout",
        ) { pageCtx -> 
            _meineglasfaser_frontend_www_pages_portal_OverviewPage()
        }
        ctx.router.register(
            "/order/",
            layoutId = "meineglasfaser.frontend.www.components.layouts.ShopLayout",
        ) { pageCtx -> 
            _meineglasfaser_frontend_www_pages_order_OrderPage()
        }
        ctx.router.register(
            "/order/success",
            layoutId = "meineglasfaser.frontend.www.components.layouts.ShopLayout",
        ) { pageCtx -> 
            _meineglasfaser_frontend_www_pages_order_OrderSuccessPage(pageCtx)
        }
        ctx.router.register(
            "/registrierung/",
            layoutId = "meineglasfaser.frontend.www.components.layouts.RegisterLayout",
        ) { pageCtx -> 
            _meineglasfaser_frontend_www_pages_registrierung_RegistrierungPage(pageCtx)
        }
        ctx.router.register(
            "/widerrufsrecht",
            layoutId = "meineglasfaser.frontend.www.components.layouts.ShopLayout",
        ) { pageCtx -> 
            _meineglasfaser_frontend_www_pages_WiderrufsrechtPage()
        }

    }
    router.addRouteInterceptor {
        path = path.removeSuffix(".html").removeSuffix(".htm")
    }

    // Dedup any leading slashes after removing the origin, just in case someone typed
    // something like `https://site.com//about` by accident. If we pass `//about` into
    // `tryRoutingTo`, Kobweb will reject it as a protocol-relative URL; instead, we
    // want it to navigate to `/about`
    router.tryRoutingTo(BasePath.remove("/" + window.location.href.removePrefix(window.origin).trimStart('/')), UpdateHistoryMode.REPLACE)

    // For SEO, we may bake the contents of a page in at build time. However, we will
    // overwrite them the first time we render this page with their composable, dynamic
    // versions. Think of this as poor man's hydration :)
    // See also: https://en.wikipedia.org/wiki/Hydration_(web_development)
    val root = document.getElementById("_kobweb-root")!!
    while (root.firstChild != null) { root.removeChild(root.firstChild!!) }

    renderComposable(rootElementId = "_kobweb-root") {
        meineglasfaser.frontend.www.AppEntry {
            router.renderActivePage()
        }
    }
}
